import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useImperativeHandle, useRef, } from 'react';
import clsx from 'clsx';
import classes from './Input.module.css';
import { useAutofocus } from '../hooks/useAutofocus';
export const Input = forwardRef(({ variant, className, autoFocus, ...props }, ref) => {
    const inputRef = useRef();
    useImperativeHandle(ref, () => inputRef.current);
    useAutofocus(inputRef, autoFocus);
    return (_jsx("input", { ref: inputRef, autoComplete: 'off', className: clsx(classes['uikit-input'], getClassNameByVariant(variant), className), ...props }));
});
Input.displayName = 'Input';
function getClassNameByVariant(variant) {
    switch (variant) {
        case 'background':
            return classes['uikit-input__background'];
        case 'transparent':
            return classes['uikit-input__transparent'];
        case 'border':
        default:
            return classes['uikit-input__border'];
    }
}
//# sourceMappingURL=Input.js.map